import { Application, Feature, Functionality, FunctionalityType } from '@frontend/functionality/types';
import { useModals } from '@frontend/modal';
import { useAccountRepository, useLicenseRepository } from '@frontend/repository';
import { SettingClient } from '@frontend/setting/api';
import { SettingKey } from '@frontend/setting/types';
import { useEffect, useState } from 'react';

import { useAppDispatch } from '../../../redux/store';

export const useLabels = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const { openModal, closeModal } = useModals();
    const { functionalities } = useLicenseRepository();
    const [functionality, setFunctionality] = useState<Functionality | null>(null);
    const [defaultSpotId, setDefaultSpotId] = useState<string | null>(null);
    const listId = 'barcode-list';

    useEffect(() => {
        if (!functionalities || functionalities.length === 0) {
            return;
        }
        const foundFunctionality = functionalities.find(
            (func) => func.application === Application.LAUNDRY && func.type === FunctionalityType.CORPORATE && func.feature === Feature.LABELS
        );
        if (!foundFunctionality) return;
        setFunctionality(foundFunctionality);
    }, [functionalities]);

    useEffect(() => {
        if (!functionality) return;
        SettingClient.fetchSettings({ account_id: functionality.account_id, entity_id: functionality.id }).then((res) => {
            if (res.results.length === 0) return;
            const defaultSpotIdSetting = res.results.find((setting) => setting.key === SettingKey.DEFAULT_SPOT_ID);
            if (!defaultSpotIdSetting) return;
            setDefaultSpotId(defaultSpotIdSetting.value as string | null);
        });
    }, [functionality]);

    return {
        currentAccount,
        dispatch,
        openModal,
        closeModal,
        defaultSpotId,
        listId
    };
};
